var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "van-popup",
        {
          style: { width: "90%", backgroundColor: "#eae9e9" },
          attrs: {
            position: "right",
            "close-on-click-overlay": false,
            round: "",
          },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "冲销借款",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": _vm.close,
              "click-right": _vm.relativeFlowPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { "show-action": "", clearable: "", shape: "round" },
            on: { search: _vm.onSearch },
            model: {
              value: _vm.queryParams.title,
              callback: function ($$v) {
                _vm.$set(_vm.queryParams, "title", $$v)
              },
              expression: "queryParams.title",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-70", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c(
                    "van-pull-refresh",
                    {
                      on: { refresh: _vm.onRefresh },
                      model: {
                        value: _vm.refreshing,
                        callback: function ($$v) {
                          _vm.refreshing = $$v
                        },
                        expression: "refreshing",
                      },
                    },
                    [
                      _c(
                        "van-list",
                        {
                          staticClass: "p-l-20 p-r-20 p-b-20",
                          attrs: {
                            "immediate-check": false,
                            error: _vm.error,
                            finished: _vm.finished,
                            "finished-text": "没有更多了",
                          },
                          on: {
                            "update:error": function ($event) {
                              _vm.error = $event
                            },
                            load: _vm.getList,
                          },
                          model: {
                            value: _vm.loading,
                            callback: function ($$v) {
                              _vm.loading = $$v
                            },
                            expression: "loading",
                          },
                        },
                        _vm._l(_vm.list, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "bg-FF p-20 m-t-20 b-r-10",
                              style: {
                                border: item.activated
                                  ? "3px solid #F8B91A"
                                  : "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.change(item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex col-center row-between" },
                                [
                                  _c("img", {
                                    staticClass: "w-52 h-52",
                                    attrs: {
                                      src: `${_vm.image_base_url}/zhengxuanlist_icon.png`,
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10",
                                    },
                                    [_vm._v(" " + _vm._s(item.userName) + " ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-26 bg-FFFAEC cor-F8B91A p-l-10 p-r-10 p-b-6 p-t-6 border-7",
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.businessNo) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "van-row",
                                {
                                  staticClass: "m-t-10",
                                  attrs: { type: "flex", align: "center" },
                                },
                                [
                                  _c("van-col", { attrs: { span: "10" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "cor-88 font-30" },
                                      [_vm._v("所属部门")]
                                    ),
                                  ]),
                                  _c("van-col", { attrs: { span: "14" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cor-33 font-30 van-multi-ellipsis--l3",
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.deptName) + " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "van-row",
                                {
                                  staticClass: "m-t-10",
                                  attrs: { type: "flex", align: "center" },
                                },
                                [
                                  _c("van-col", { attrs: { span: "10" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "cor-88 font-30" },
                                      [_vm._v("借款时间")]
                                    ),
                                  ]),
                                  _c("van-col", { attrs: { span: "14" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cor-33 font-30 van-multi-ellipsis--l3",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.debtTime
                                                ? _vm
                                                    .moment(item.debtTime)
                                                    .format(
                                                      "YYYY-MM-DD hh:mm:ss"
                                                    )
                                                : ""
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "van-row",
                                {
                                  staticClass: "m-t-10",
                                  attrs: { type: "flex", align: "center" },
                                },
                                [
                                  _c("van-col", { attrs: { span: "10" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "cor-88 font-30" },
                                      [_vm._v("借款金额")]
                                    ),
                                  ]),
                                  _c("van-col", { attrs: { span: "14" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cor-33 font-30 van-multi-ellipsis--l3",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.debtAmount + " 元") +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "van-row",
                                {
                                  staticClass: "m-t-10",
                                  attrs: { type: "flex", align: "center" },
                                },
                                [
                                  _c("van-col", { attrs: { span: "10" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "cor-88 font-30" },
                                      [_vm._v("事由")]
                                    ),
                                  ]),
                                  _c("van-col", { attrs: { span: "14" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cor-33 font-30 van-multi-ellipsis--l3",
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.debtReason) + " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "van-row",
                                {
                                  staticClass: "m-t-10",
                                  attrs: { type: "flex", align: "center" },
                                },
                                [
                                  _c("van-col", { attrs: { span: "10" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "cor-88 font-30" },
                                      [_vm._v("已还款金额")]
                                    ),
                                  ]),
                                  _c("van-col", { attrs: { span: "14" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cor-33 font-30 van-multi-ellipsis--l3",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(item.repayAmount + " 元") +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "van-row",
                                {
                                  staticClass: "m-t-10",
                                  attrs: { type: "flex", align: "center" },
                                },
                                [
                                  _c("van-col", { attrs: { span: "10" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "cor-88 font-30" },
                                      [_vm._v("状态")]
                                    ),
                                  ]),
                                  _c("van-col", { attrs: { span: "14" } }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cor-33 font-30 van-multi-ellipsis--l3",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.state === "1"
                                                ? "已完结"
                                                : "未完结"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }